import { PrescriptionResponse, Refraction, refractionSchema } from '../schema'

export const mockRefraction = {
  r_sph: 1,
  l_sph: 1,
  r_cyl: 0,
  l_cyl: 0,
  r_axis: 10,
  l_axis: 10,
  prism: true,
  right_na_te: 'in',
  left_na_te: 'out',
  right_ha_ba: 'up',
  left_ha_ba: 'up',
  r_prism1: 2,
  l_prism1: 3,
  r_prism2: 2,
  l_prism2: 4,
  r_add: 1.5,
  l_add: 1.5,
  r_pd: 30,
  l_pd: 30,
  l_visus: 0,
  r_visus: 0,
  optometrist: 23456,
} satisfies Refraction

export const mockPrescription = {
  id: 1,
  name: 'Mock Prescription',
  remark: 'this is mock data',
  create_date: '2021-01-01',
  optometrist_name: 'Optometrist',
  ...mockRefraction,
} satisfies PrescriptionResponse

export const mockParsedRefraction = refractionSchema.parse(mockRefraction)
